import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState(['lang']),
  },
});

export default new Vuex.Store({
  ...core,
  modules: {
    core,
    records,
    domains,
    subdomains,
  },
  getters: {
    user: (state) => state.user,
    isLiteUser: (state) => {
      return state.user.roles && state.user.roles.indexOf('groove_future_apps') === -1;
    },
  },
});
